/** Safe workbook/CSV download name from a table title. */
export function tableExportFileName(label) {
  const cleaned = String(label || '')
    .trim()
    .replace(/[<>:"/\\|?*\u0000-\u001f]+/g, '')
    .replace(/\s+/g, ' ')
    .slice(0, 120);
  return cleaned || 'table';
}

function humanizeTableId(tableId) {
  const last = String(tableId || '')
    .split('.')
    .pop();
  return last.replace(/[-_]+/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function buildGridToolbarExportProps({ title, tableId, ...toolbarProps } = {}) {
  const fileName = tableExportFileName(title || humanizeTableId(tableId));
  return {
    ...toolbarProps,
    csvOptions: {
      utf8WithBom: true,
      fileName,
      ...(toolbarProps.csvOptions || {}),
    },
    excelOptions: {
      fileName,
      ...(toolbarProps.excelOptions || {}),
    },
  };
}
